export const routes = [
  {
    name: 'offerItem_list',
    path: '/offerItem',
    componentConfig: [
      {
        component: 'EndpointListContainer',
        props: {
          endpoint: 'offerItem',
          slice: 'offerItem/offerItem/list',
          selectAction: {
            preview: {
              meta: {
                modal: {
                  body: [
                    {
                      component: 'OfferItemDetailContainer'
                    }
                  ]
                }
              }
            },
            edit: {
              type: 'offerItem/offerItem/edit/start',
              meta: {
                modal: {
                  title: 'offerItem.actions.update',
                  body: [
                    {
                      component: 'OfferItemEditForm'
                    }
                  ]
                }
              }
            }
          }
        },
        children: [
          {
            component: 'Grid',
            props: {
              title: 'offerItem.module.name',
              config: {
                columns: {
                  id: {
                    label: 'offerItem.entity.id'
                  },
                  offer: {
                    label: 'offerItem.entity.offer',
                    display: {
                      type: 'objectProps',
                      props: ['description']
                    }
                  },
                  budgetLine: {
                    label: 'offerItem.entity.budgetLine',
                    display: {
                      type: 'objectProps',
                      props: ['name']
                    }
                  },
                  description: {
                    label: 'offerItem.entity.description'
                  },
                  cost: {
                    label: 'offerItem.entity.cost'
                  },
                  updatedAt: {
                    label: 'offerItem.entity.updatedAt',
                    display: {
                      type: 'datetime'
                    }
                  }
                },
                filtersConfig: [],
                actions: [
                  {
                    label: 'offerItem.actions.create',
                    type: 'create',
                    icon: 'plus',
                    action: {
                      type: 'offerItem/offerItem/edit/start',
                      meta: {
                        modal: {
                          title: 'offerItem.create',
                          body: [
                            {
                              component: 'OfferItemCreateForm'
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                recordActions: [
                  {
                    label: '',
                    type: 'edit',
                    icon: 'pen',
                    action: {
                      type: 'offerItem/offerItem/edit/start',
                      meta: {
                        modal: {
                          title: 'offerItem.update',
                          body: [
                            {
                              component: 'OfferItemEditForm'
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    label: '',
                    type: 'delete',
                    icon: 'trash',
                    action: {
                      type: 'offerItem/offerItem/list/delete',
                      meta: {
                        API: {
                          endpoint: 'offerItem',
                          operation: 'delete'
                        },
                        confirm: {
                          props: {
                            title: 'ims.confirm.delete.title',
                            message: 'ims.confirm.delete.message',
                            confirmText: 'ims.confirm.delete.confirmText',
                            cancelText: 'ims.confirm.delete.cancelText'
                          },
                          confirmed: false
                        }
                      }
                    }
                  }
                ]
              }
            }
          }
        ]
      }
    ],
    exact: true,
    section: false,
    module: 'offerItem',
    label: 'offerItem.module.name',
    icon: null
  }
];
